export const KYC_TYPES_LOWER = new Set([
  "passport",
  "national_identity_card_front",
  "national_identity_card_back",
  "residence_permit_front",
  "residence_permit_back",
  "dni",
  "nie",
  "dni/nie",
  "national identity card",
  "residence permit card",
  "other identity document",
]);

export const isKycTenantDoc = (doc) => {
  if (!doc) return false;
  const category = (doc.categoryKey || "").toLowerCase();
  if (category === "identification") return true;
  const type = (doc.type || "").toLowerCase();
  const normalized = type.replace(/\s+/g, "_");
  if (KYC_TYPES_LOWER.has(type) || KYC_TYPES_LOWER.has(normalized)) return true;
  if (
    type.includes("passport") ||
    type.includes("national identity") ||
    type.includes("identity card") ||
    type.includes("residence permit") ||
    type === "dni" ||
    type === "nie" ||
    type.includes("dni/nie")
  )
    return true;
  const bucket = (
    doc.bucketName ||
    doc.documentAnalysisData?.bucketName ||
    ""
  ).toLowerCase();
  if (
    bucket.includes("passport") ||
    bucket.includes("national identity") ||
    bucket.includes("residence permit")
  )
    return true;
  const fileName = (doc.file_name || "").toLowerCase();
  if (fileName.includes("onfido")) return true;
  return false;
};

export const isKycReviewFile = (file, tenantDocsData) => {
  if (!file) return false;
  const docName = (file.documentName || file.bucketName || "").toLowerCase();
  if (
    docName.includes("passport") ||
    docName.includes("national identity") ||
    docName.includes("residence permit") ||
    docName === "dni" ||
    docName === "nie" ||
    docName.includes("dni/nie")
  )
    return true;
  const matched = tenantDocsData.find(
    (doc) => doc?.file_name === file.fileName || doc?._id === file.documentId
  );
  return isKycTenantDoc(matched);
};
